<template>
  <div class="layout">
    <div class="head">
      <slot name="head"></slot>
    </div>
    <div class="main">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  @apply bg-white;
  color: var(--resume-font-color);
  font-family: var(--resume-font-family);
  padding: var(--resume-margin);
  line-height: var(--resume-line-height);
  :deep(h1),
  :deep(h2),
  :deep(h3) {
    @apply font-bold;
    color: var(--resume-primary-color);
    font-family: var(--resume-font-family);
  }
  :deep(.header) {
    @apply flex-col items-center;
    > div:first-child {
      @apply flex flex-col items-center;
    }
  }

  :deep(.contact) {
    @apply ml-0 !important;
    .phone-location-container {
      @apply flex-row-reverse justify-center;
    }
    .email-website-container,
    .internet-profiles-container {
      @apply flex-row justify-center flex-wrap;
    }

    .internet-profiles-container span {
      &:not(:last-child)::after {
        content: '|';
        @apply mx-1;
      }
    }

    .divider-url,
    .divider-address {
      &:after {
        @apply mx-1;
        content: '|';
      }
    }
  }

  :deep(.description > *) {
    @apply w-[95%] self-end;
  }

  :deep(.reference) {
    @apply flex flex-col items-end;
    div {
      @apply self-start;
    }
    span {
      @apply w-[95%];
    }
  }

  :deep(.additional) {
    ul {
      @apply ml-[5%];
    }
  }

  :deep(.award) {
    @apply flex flex-col;
    span {
      @apply w-[95%] self-end;
    }
  }

  :deep(.publication-text) {
    @apply flex flex-col items-end;
    > span {
      @apply w-[95%];
    }
  }

  :deep(.experience) {
    @apply flex flex-col;
    .dates {
      @apply whitespace-nowrap;
    }
    .details,
    .score {
      @apply w-[95%] self-end;
    }
  }

  :deep(.description) {
    @apply flex flex-col items-center;
  }

  .sidebar,
  .main,
  .head {
    grid-area: sidebar;
    @apply bg-transparent;
  }

  .head {
    @apply pb-0;
  }

  .sidebar,
  .main {
    @apply pt-2-em;
  }
  .sidebar {
    background-color: var(--resume-background-color);
  }
}
</style>
